export const sql = sql => ({ sql })